const initialUrlInfo = (params) => ({
  url: '',
  subject: '',
  type: 'website',
  ...params,
})

export default initialUrlInfo
